// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressZa_v-icon_2eb3n","nsAddressForm":"NsAddressZa_nsAddressForm_2tX1B","dualColumn":"NsAddressZa_dualColumn_1Jowu","firstCol":"NsAddressZa_firstCol_nOn6D"};